import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import { Loading, Preloader } from '@/src/ui';

interface PublicRouteProps {
    userExists: boolean;
    loading?: boolean;
}

const PublicOnlyRoute: React.FC<PublicRouteProps> = ({ userExists, loading }) => {
    if (loading) {
        return <Loading />;
    }

    if (userExists && !localStorage.getItem('hasLoggedOut')) {
        const isLocal = window.location.href.includes('localhost');
        const localUrl = 'http://localhost:5174';
        // Redirect to other Paradigm site if needed
        const params = new URLSearchParams(window.location.search);
        const redirect = params.get('redirect');
        if (redirect) {
            switch (redirect) {
                case 'teacher':
                    window.location.href = isLocal
                        ? `${localUrl}/authCallback`
                        : 'https://teacher.paradigmmath.com/authCallback';
                    break;
                case 'teacher-dev':
                    window.location.href = isLocal
                        ? `${localUrl}/authCallback`
                        : 'https://teacher-dev.paradigmmath.com/authCallback';
                    break;
                case 'practice':
                    window.location.href = 'https://practice.paradigmmath.com';
                    break;
                case 'interactivebook':
                    window.location.href = 'https://interactivebook.paradigmmath.com';
                    break;
                default:
                    break;
            }
            return <Preloader message="Logging you in..." />;
        }

        return <Navigate to="/dashboard" replace />;
    }

    return <Outlet />;
};

export default PublicOnlyRoute;
